"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultStaffModeContext = void 0;
var _defaultStaffInstructions = require("./defaultStaffInstructions");
var DefaultStaffModeContext = exports.DefaultStaffModeContext = {
  preScripts: _defaultStaffInstructions.DefaultStaffInstructionsPreScripts,
  aboutPet: _defaultStaffInstructions.DefaultStaffInstructionsPetDetails,
  basicOwnerDetails: _defaultStaffInstructions.DefaultStaffInstructionsOwnerDetails,
  fullOwnerDetails: _defaultStaffInstructions.DefaultStaffInstructionsOwnerDetails
};